import toast from 'react-hot-toast'

export const showErrorToast = (message: string | any) => {
  toast.dismiss() // clears all existing toasts
  toast.error(message)
}

export const showSuccessToast = (message: string | any) => {
  toast.dismiss() // clears all existing toasts
  toast.success(message)
}
